import { getPluralFormForHandlingUnitType } from "@/Data/getPluralFormForHandlingUnitType";
import { getSingularFormForHandlingUnitType } from "@/Data/getSingularFormForHandlingUnitType";
import { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";
import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

interface LineItemsDimensionsQuestionBubble {
  handlingUnitType: HandlingUnitType | undefined;
  onAddLineItem: (() => void) | undefined;
}

const LineItemsDimensionsQuestionBubble: React.FC<
  LineItemsDimensionsQuestionBubble
> = (props: LineItemsDimensionsQuestionBubble) => {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">Dimensions</T>
          <T size="xs" color="secondary">
            Correct dimensions ensure you get accurate quotes from carriers.
          </T>
          {props.handlingUnitType &&
          props.handlingUnitType !== HandlingUnitType.Other ? (
            <>
              <T size="xs" color="secondary">
                {`If you are shipping multiple identical ${getPluralFormForHandlingUnitType(
                  props.handlingUnitType,
                ).toLowerCase()}, this should be the dimensions and weight of each single ${getSingularFormForHandlingUnitType(
                  props.handlingUnitType,
                ).toLowerCase()}.`}
              </T>
              {props.onAddLineItem && (
                <T size="xs" color="secondary">
                  {`Please add an additional row if you are shipping multiple ${getPluralFormForHandlingUnitType(
                    props.handlingUnitType,
                  ).toLowerCase()} with different products, dimensions or weights.`}
                </T>
              )}
            </>
          ) : (
            <>
              <T size="xs" color="secondary">
                {`If you are shipping multiple identical handling units, this should be the dimensions and weight of each individual one.`}
              </T>
              {props.onAddLineItem && (
                <T size="xs" color="secondary">
                  {`If you are shipping multiple handling units that have different dimensions or weights, please add an additional row for each one.`}
                </T>
              )}
            </>
          )}
          <T size="xs" color="secondary">
            {`Maximum handling unit dimensions: 50ft long x 96" wide x 102" high`}
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/measuring-your-freight"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
};
export default LineItemsDimensionsQuestionBubble;
